module.exports = __webpack_public_path__ + "media/images/lb/525-e84ef1c6e1ca9086ff8e1c534dfde81e.svg";